import routes, { renderRoutes } from '@/routes'
import ErrorBoundary from '@components/ErrorBoundary'
import GlobalStyles from '@components/GlobalStyles'
import ScrollReset from '@components/ScrollReset'
import { AuthProvider } from '@contexts/JWTAuthContext'
import MomentUtils from '@date-io/moment'
import useSettings from '@hooks/useSettings'
import {
  CssBaseline,
  Slide,
  StylesProvider,
  ThemeProvider,
  jssPreset
} from '@material-ui/core'
import { MuiPickersUtilsProvider } from '@material-ui/pickers'
import api from '@micmnt/apis'
import { createDashboardTheme } from '@theme'
import { createBrowserHistory } from 'history'
import { create } from 'jss'
import rtl from 'jss-rtl'
import { SnackbarProvider } from 'notistack'
import { memo } from 'react'
import { Router } from 'react-router-dom'
import 'moment/locale/it'
import { ChartsProvider } from '@contexts/ChartsContext'
import apiConfig from './api/config'
import { configuration } from './config'

const jss = create({ plugins: [...jssPreset().plugins, rtl()] })
const history = createBrowserHistory()

// Inizializzazione del servizio di chiamate API
api.init({
  baseUrl: configuration.apiUrl,
  savedUrls: apiConfig,
  jwtTokenName: 'accessToken',
  errorInterceptor: (error) => {
    const errorStatus = error?.response?.data?.error?.statusCode || null
    const errorMessage = error?.response?.data?.error?.message || null
    const isTokenError = errorMessage?.toLowerCase()?.includes('token')
    if (errorStatus === 401 && errorMessage && isTokenError) {
      window.localStorage.removeItem('accessToken')
      // window.location.replace(`${configuration.dashboardUrl}/login`)
      window.location.replace(`${window.location.origin}/login`)
    }
  }
})

const App = () => {
  // Inizializzazione Smartlook
  React.useEffect(() => {
    if (process.env.NODE_ENV !== 'production') return
    if (!window.smartlook) {
      ((d) =>{
        const o = (window.smartlook = function() { o.api.push(arguments); });
        const h = d.getElementsByTagName('head')[0];
        const c = d.createElement('script');
        o.api = [];
        c.async = true;
        c.type = 'text/javascript';
        c.src = 'https://web-sdk.smartlook.com/recorder.js';
        h.appendChild(c);
      })(document);
    }
    window.smartlook('init', '32afa7662b4d96449aa5e73f4a98c70239ef7f62', { region: 'eu' });
  }, []);
  const { settings } = useSettings()

  // creo il tema
  const theme = createDashboardTheme({
    direction: settings.direction,
    responsiveFontSizes: settings.responsiveFontSizes,
    theme: settings.theme
  })

  return (
    <ThemeProvider theme={theme}>
      <StylesProvider jss={jss}>
        <CssBaseline />
        <MuiPickersUtilsProvider utils={MomentUtils} locale='it'>
          <SnackbarProvider
            classes={{ root: 'snackbarProviderRoot' }}
            maxSnack={5}
            TransitionComponent={Slide}
            anchorOrigin={{
						  vertical: 'bottom',
						  horizontal: 'left'
            }}
            autoHideDuration={4000}
          >
            <ErrorBoundary>
              <Router history={history}>
                <ChartsProvider>
                  <AuthProvider>
                    <GlobalStyles />
                    <ScrollReset />
                    {renderRoutes(routes)}
                  </AuthProvider>
                </ChartsProvider>
              </Router>
            </ErrorBoundary>
          </SnackbarProvider>
        </MuiPickersUtilsProvider>
      </StylesProvider>
    </ThemeProvider>
  )
}

export default memo(App)
